import React from 'react';

import StyledTooltip from '../../General/Tooltip/StyledTooltip';
import { Button, Typography } from '@mui/material';
import type { ISidebarBtnConfig } from '../Ribbon/RibbonConfig';
import i18next from 'i18next';

import styles from './SidebarButton.module.scss';
import { useSelector } from 'react-redux';
import { selectedSidepanelName } from '../../../Redux/SelectedSidepanelSlice';
import { ReduxUpdater } from '../../../pdf/ReduxUpdater';
import { GlobalVariables } from '../../../pdf/GlobalVariables';
import { upperCaseBegin } from '../../../utils';

export default (props: ISidebarBtnConfig) => {
    const buttonRef = React.useRef<HTMLButtonElement>(null);

    const [tooltipVisible, setTooltipVisible] = React.useState(false);

    const selectedSidepanel = useSelector(selectedSidepanelName);

    const buttonStyles = (buttonName: string): string => {
        const buttonStyles = [styles.sidebarButton];
        if (selectedSidepanel === buttonName) {
            buttonStyles.push(styles.sidebarButtonSelected);
        }
        if (props.buttonDisabled) {
            buttonStyles.push(styles.sidebarButtonDisabled);
        }

        return buttonStyles.join(' ');
    };

    const key = `${props.buttonKey}Sidepanel`;
    GlobalVariables.registeredCommands[key] = () => {
        ReduxUpdater.selectedSidepanel =
            selectedSidepanel === props.buttonKey ? null : props.buttonKey;
    };

    const tooltipTitle = (
        <>
            <Typography color="inherit">
                {i18next.t(`sidebar.title.${props.buttonKey}`)}
                <span
                    style={{
                        fontSize: '12px',
                        fontWeight: 'bold',
                        float: 'right',
                        margin: '4px 0px 0px 10px',
                    }}
                >
                    {i18next.exists(`shortcut.${ReduxUpdater.shortcuts[key]}`)
                        ? i18next.t(`shortcut.${ReduxUpdater.shortcuts[key]}`)
                        : ReduxUpdater.shortcuts[key] ?? ''}
                </span>
            </Typography>
            {i18next.t(`sidebar.hint.${props.buttonKey}`)}
        </>
    );

    const button = (
        <Button
            id={
                GlobalVariables.isForTestRun
                    ? `sidebarBtn${upperCaseBegin(props.buttonKey)}`
                    : undefined
            }
            ref={buttonRef}
            className={buttonStyles(props.buttonKey)}
            onClick={GlobalVariables.registeredCommands[key]}
            onMouseEnter={() => setTooltipVisible(true)}
            onMouseLeave={() => setTooltipVisible(false)}
            disabled={props.buttonDisabled}
        >
            {props.icon}
        </Button>
    );

    return (
        <StyledTooltip
            key={`sidebarBtn-${props.buttonKey}`}
            hidden={tooltipVisible}
            title={tooltipTitle}
            placement="right"
        >
            {props.buttonDisabled ? <span>{button}</span> : button}
        </StyledTooltip>
    );
};
